"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated use web Storage directly: [[ParsecSessionStorage]] is a subset of web [[Storage]]
 * interface, so it is recommended direct usage of `localStorage` of `sessionStorage`.
 *
 *
 * This class is left for compatibility reasons and will be removed in future releases.
 */
class LocalSessionStorage {
    constructor(prefix = "_pss_") {
        this.prefix = prefix;
        this.ls = localStorage;
        if (!this.ls)
            throw new Error("No local storage found");
    }
    getItem(key) {
        return this.ls.getItem(this.prefix + key);
    }
    removeItem(key) {
        this.ls.removeItem(this.prefix + key);
    }
    setItem(key, value) {
        this.ls.setItem(this.prefix + key, value);
    }
}
//# sourceMappingURL=LocalSessionStorage.js.map